import React from "react";
import Signupstyles from "../assets/stylesheets/SignupForm.module.css";
export default function SignupForm() {
  return (
    <div id="mc_embed_signup" className={Signupstyles.signupContainer}>
      <form
        action="https://farmciti.us17.list-manage.com/subscribe/post?u=f079c2bb7b305e6da1212a526&amp;id=64aeb253f7&amp;f_id=00b683e0f0"
        method="post"
        id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
        className="validate"
        target="_blank"
        noValidate
      >
        <h2>Subscribe to our newsletter</h2>
        <div className="mc-field-group">
          <input
            type="text"
            name="FNAME"
            className="required text"
            id="mce-FNAME"
            required
            placeholder="Your first name"
          />
        </div>
        <div className="mc-field-group">
          <input
            type="email"
            name="EMAIL"
            className="required email"
            id="mce-EMAIL"
            required
            placeholder="Your email address"
          />
        </div>
        {/* 봇 차단용 숨김 필드 */}
        <div style={{ position: "absolute", left: "-5000px" }} aria-hidden="true">
          <input
            type="text"
            name="b_f079c2bb7b305e6da1212a526_64aeb253f7"
            tabIndex="-1"
            value=""
            readOnly
          />
        </div>
        <div className="clear">
          <input
            type="submit"
            value="Subscribe"
            name="subscribe"
            id="mc-embedded-subscribe"
            className={Signupstyles.button}
          />
        </div>
      </form>
    </div>
  );
}
